export const SUPPORT_EMAIL = 'support@ekoz.ai';
export const FINANCE_EMAIL = 'steve@thedigitent.com';
